import React from 'react';
import { IconProps } from '../../../../assets/icons/types';

const OrderPickedIcon = ({ className, color }: IconProps) => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.72687 7.26318H2.79102V16C2.79102 17.1046 3.68645 18 4.79102 18H14.2121C15.3166 18 16.2121 17.1046 16.2121 16V7.26318H12.6331"
        stroke={color ?? 'current-color'}
      />
      <path
        d="M5.92301 2.78955H3.00195C1.89738 2.78955 1.00195 3.68498 1.00195 4.78955V5.26324C1.00195 6.3678 1.89738 7.26324 3.00195 7.26324H5.92301M12.6335 2.78955H16.002C17.1065 2.78955 18.002 3.68498 18.002 4.78955V5.26323C18.002 6.3678 17.1065 7.26324 16.002 7.26324H13.5283"
        stroke={color ?? 'current-color'}
      />
      <circle cx="9.50288" cy="5.02632" r="4.02632" stroke={color ?? 'current-color'} />
      <path
        d="M10.8444 4.5791L9.16298 6.36858L8.16016 5.61695"
        stroke={color ?? 'current-color'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="6.36914" y="14.4951" width="6.26316" height="1.04386" rx="0.52193" fill="white" />
      <path
        d="M7.41211 13.9735C7.41211 12.8204 8.34681 11.8857 9.49983 11.8857C10.6528 11.8857 11.5875 12.8204 11.5875 13.9735V14.4954H7.41211V13.9735Z"
        fill="white"
      />
      <circle cx="9.5024" cy="11.3637" r="0.52193" fill="white" />
    </svg>
  );
};

export default OrderPickedIcon;
